import React from 'react';

const PrescriptionList = ({ prescriptions }) => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg">
      <h2 className="text-3xl font-semibold text-primary mb-6">
        Lista de Prescrições
      </h2>
      <ul className="space-y-6">
        {prescriptions.map((prescription, index) => (
          <li
            key={index}
            className="p-6 bg-gray-50 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 border-l-4 border-primary"
          >
            <p className="text-lg font-medium text-gray-800 mb-2">
              <strong>Medicamento:</strong> {prescription.medication}
            </p>
            <p className="text-gray-600">
              <strong>Dosagem:</strong> {prescription.dosage}
            </p>
            <p className="text-gray-600">
              <strong>Frequência:</strong> {prescription.frequency}
            </p>
            <p className="text-gray-600">
              <strong>Via de Administração:</strong>{' '}
              {prescription.administrationRoute}
            </p>
            <p className="text-gray-600">
              <strong>Médico:</strong> {prescription.doctor}
            </p>
            <p className="text-gray-600">
              <strong>Data da Prescrição:</strong> {prescription.date}
            </p>
            <button
              className="mt-4 bg-primary text-white py-2 px-4 rounded-lg hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50"
              onClick={() => alert(`Prescrição ${index + 1} baixada`)}
            >
              Baixar PDF
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PrescriptionList;
